import { WC_REGISTRY_MARKER } from "./types";
export const createRegistryConnector = (wallet, isMobilePlatform, providerName) => ({
    id: wallet.id,
    name: wallet.name,
    icon: wallet.icon,
    type: 'walletConnect',
    order: wallet.order,
    isMobileSupported: wallet.isMobileSupported,
    hasBrowserExtension: wallet.hasBrowserExtension,
    installUrl: wallet.installUrl,
    extensionNotFound: wallet.hasBrowserExtension ? !isMobilePlatform : false,
    providerName,
    [WC_REGISTRY_MARKER]: wallet,
});
